import type { TPlainObject } from '@flatbiz/utils';
import { fbaHooks } from '../fba-hooks/index.js';

export const [useLocalLoadingCtx, LocalLoadingCtxProvider] =
  fbaHooks.createCtx<{
    onRequest: (params?: TPlainObject) => void;
  }>();
